import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function initLogosCarousel(): void {
    const $logosCarouselContainer = document.querySelectorAll('.js-logos-slider');

    $logosCarouselContainer.forEach($container => {
        new LogosCarousel($container as HTMLElement);
    });
}

class LogosCarousel {
    $el: HTMLElement;
    swiper: Swiper | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        if (this.$el) {
            this.swiper = new Swiper(this.$el, {
                modules: [Autoplay],
                slidesPerView: 'auto',
                centeredSlides: true,
                speed: 6000,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                allowTouchMove: false,
            });
        }
    }
}